// extracted by mini-css-extract-plugin
module.exports = {"notification":"notification_notification__2nlKy","notificationActions":"notification_notificationActions__1Rnbp"};